document.addEventListener("DOMContentLoaded", function() {
    const toggleButton = document.querySelector(".custom-mobile-buy-buttons-more");
    const optionsBox = document.querySelector(".custom-additional-buy-options");
  
    if (toggleButton && optionsBox) {
      const moreText = toggleButton.getAttribute("data-more-text") || "More options";
      const lessText = toggleButton.getAttribute("data-less-text") || "Less options";
  
      toggleButton.addEventListener("click", function() {
        const isVisible = optionsBox.classList.contains("show");
  
        if (isVisible) {
          optionsBox.classList.remove("show");
          toggleButton.textContent = moreText;
        } else {
          optionsBox.classList.add("show");
          toggleButton.textContent = lessText;
        }
      });
    }
  });